import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  linksPageAdditionalMeta,
  linksPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import LinksPageMainContainer from '../../components/links/LinksPageMainContainer';
import HeaderBanner from '../../components/general/HeaderBanner';
import AltHeader from '../../components/general/AltHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function LinksPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Extra Links'
        desc={`Explore Mistress Maria's verified profiles and premium content across trusted platforms. Stay connected and up to date with her latest clips, sessions, and online offerings.`}
        keywords={`Mistress Maria links, Femdom platforms, domination content, OnlyFans, ManyVids, LoyalFans, Findom, Norfolk Dominatrix, online domination, adult content links, Mistress Maria verified accounts`}
        additionalMeta={linksPageAdditionalMeta}
        structuredData={linksPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'Spoil & Treat Me!'} />
          </header>
        </div>

        {/* Main page content */}
        <LinksPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default LinksPage;
